import { createFileRoute } from "@tanstack/react-router";
import { CTABand } from "@/components/site/CTABand";
import { PhoneButton } from "@/components/site/PhoneButton";
import { CITIES, CITY_SERVICES } from "@/lib/cities";
import { comboHref, uniqueByHref } from "@/lib/combo-links";

export const Route = createFileRoute("/sitemap")({
  head: () => ({
    meta: [
      { title: "Sitemap | Phoenix Plumbing Co." },
      { name: "description", content: "Complete sitemap of Phoenix Plumbing Co. — find every service page, location page, and resource for plumbers serving Phoenix and the surrounding metro area." },
      { property: "og:title", content: "Sitemap | Phoenix Plumbing Co." },
      { property: "og:description", content: "Complete sitemap of Phoenix Plumbing Co. — find every service page, location page, and resource for plumbers serving Phoenix and the surrounding metro area." },
      { property: "og:url", content: "https://www.phoenixplumbing.co/sitemap" },
      { name: "twitter:title", content: "Sitemap | Phoenix Plumbing Co." },
      { name: "twitter:description", content: "Complete sitemap of Phoenix Plumbing Co. — find every service page, location page, and resource for plumbers serving Phoenix and the surrounding metro area." },
      { name: "robots", content: "noindex,follow" },
    ],
    links: [{ rel: "canonical", href: "https://www.phoenixplumbing.co/sitemap" }],
  }),
  component: Page,
});

function Page() {
  return (
    <>
      <section className="bg-secondary text-secondary-foreground">
        <div className="mx-auto max-w-4xl px-4 py-14">
          <h1 className="text-4xl md:text-5xl font-extrabold">Sitemap</h1>
          <p className="mt-4 text-secondary-foreground/85 text-lg">All pages on the Phoenix Plumbing Co. website.</p>
          <div className="mt-6"><PhoneButton size="lg" /></div>
        </div>
      </section>
      <article className="mx-auto max-w-3xl px-4 py-12 prose prose-lg">
        <h2>Main pages</h2><ul><li><a href="/">Home</a></li><li><a href="/about">About</a></li><li><a href="/contact">Contact</a></li><li><a href="/#services">Services</a></li><li><a href="/emergency-plumbing-phoenix">Emergency</a></li><li><a href="/areas-served">Areas Served</a></li><li><a href="/reviews">Reviews</a></li><li><a href="/blog">Blog</a></li><li><a href="/financing">Financing</a></li><li><a href="/coupons">Coupons</a></li></ul>
        <h2>City pages</h2>
        <ul>
          {CITIES.map((c) => (
            <li key={c.slug}>
              <a href={`/areas-served/${c.slug}`}>Plumber in {c.name}, AZ</a>
            </li>
          ))}
        </ul>
        <h2>City + Service pages</h2>
        <ul>
          {uniqueByHref(CITIES.flatMap((c) => CITY_SERVICES.map((s) => ({ c, s }))), ({ c, s }) => comboHref(c.slug, s.slug))
            .map(({ c, s }) => (
              <li key={`${c.slug}-${s.slug}`}>
                <a href={comboHref(c.slug, s.slug)}>
                  {s.name} in {c.name}, AZ
                </a>
              </li>
            ))}
        </ul>
      </article>
      <CTABand />
    </>
  );
}
